<template>
  <div class="detail">
    <HeaderReturn title="历史记录"></HeaderReturn>
    <div class="content">
      <div class="detail_ul">
        <ul>
          <!-- <li class="d-flex justify-between" style="color: #1484C4;">
                        <div class="d-flex">
                            <p>发起额</p>
                            <p>闪兑额</p>
                        </div>
                        <div>
                            <p>时间</p>
                        </div>
                    </li> -->
          <van-list
            v-model:loading="loading"
            :finished="finished"
            :immediate-check="false"
            finished-text="到底啦~"
            @load="onLoad"
          >
            <li
              style="color: #999999"
              class="detail_li"
              v-for="(item, index) in info"
              :key="index"
            >
              <div class="d-flex justify-between">
                <div>发起额</div>
                <div>
                  <span style="color: #f89b19">
                    {{ item.amount }}</span
                  >
                  FIL
                </div>
              </div>
              <div class="d-flex justify-between">
                <div>闪兑额</div>
                <div>
                  <span style="color: #f89b19">
                    {{ item.enText }}</span
                  >
                  USDT2
                </div>
              </div>
              <div class="d-flex justify-between">
                <div>时间</div>
                <div>
                  {{ item.createTime }}
                </div>
              </div>
            </li>
          </van-list>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mainApiData } from "@/request/api.js";
export default {
  name: "",
  data() {
    return {
      info: [],

      loading: false,
      finished: false,
      pageNo: 0,
      pageSize: 10,
    };
  },
  created() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.pageNo++;
      let parme = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      mainApiData.flashLog(parme).then((res) => {
        if (res.data.code == 200) {
          for (let i = 0; i < res.data.data.records.length; i++) {
            this.info.push(res.data.data.records[i]);
          }
          this.total = res.data.total;
        }
      });
      this.loading = false;
      if (this.info.length >= this.total) {
        this.finished = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .van-nav-bar__title {
  color: #f89b19 !important;
  font-size: 20px;
  font-weight: 600;
}
.detail {
  margin: 50px 10px;
  color: #ffffff;

  ::v-deep .van-nav-bar__title {
    color: #fff;
  }

  .content {
    margin-top: 15px;

    .title {
      display: flex;
      justify-content: space-between;
    }

    .detail_ul {
      ul {
        li {

          border-radius: 4px;
    

          margin: 20px 0;

          div {
            padding: 3px 3px;
            // margin: 0px 0 10px 0;

            // background: rgba(20, 132, 195, 0.2);
            // /* 黄/主题 */

            // border-radius: 4px;
          }

          border: 0.5px solid #f89b19;
          padding: 5px 0;
        }
      }
    }

    .title div {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>
